import { render } from "./HowToUse.vue?vue&type=template&id=71a712b9"
import script from "./HowToUse.vue?vue&type=script&lang=js"
export * from "./HowToUse.vue?vue&type=script&lang=js"

import "./HowToUse.vue?vue&type=style&index=0&id=71a712b9&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__